import React, { useState } from 'react';
import cx from 'classnames';
import { MDText } from 'i18n-react';

import cypressIds from 'Components/cypress_ids.json';
import TextLink from 'Components/shared/TextLink/TextLink';
import { applyCypressData } from 'Utilities/helpers';

import localTexts from './VehicleSpecsDetailsButton.texts';

import styles from './VehicleSpecsDetailsButton.module.scss';

const LocalT = new MDText(localTexts);

interface VehicleSpecsDetailsButtonProps {
	classNames?: {
		container?: string;
		text?: string;
	};
	cypressId?: string;
	modal: React.ReactElement;
	onModalClose?: () => void;
	onModalOpen?: () => void;
	textLinkProps?: {
		onClick?: () => void;
	};
}

export const VehicleSpecsDetailsButton: React.FC<VehicleSpecsDetailsButtonProps> = ({
	classNames,
	cypressId,
	modal,
	onModalClose,
	onModalOpen,
	textLinkProps = {},
}) => {
	const [isModalOpen, setIsModalOpen] = useState(false);

	const onDetailsLinkClicked = () => {
		setIsModalOpen(true);
		onModalOpen?.();
	};

	const dismissModal = () => {
		setIsModalOpen(false);
		onModalClose?.();
	};

	const onTextLinkOnClick = textLinkProps.onClick
		? () => {
				onDetailsLinkClicked();
				textLinkProps.onClick?.();
			}
		: onDetailsLinkClicked;

	return (
		<>
			<TextLink
				{...textLinkProps}
				classNames={{
					container: cx(styles.detailsLink, classNames?.container),
					text: classNames?.text,
				}}
				onClick={onTextLinkOnClick}
				text={`${LocalT.translate('details')}`}
				{...applyCypressData(cypressId || cypressIds.links.details)}
			/>
			{isModalOpen && React.cloneElement(modal, { onDismissModal: dismissModal })}
		</>
	);
};
